import React from 'react';

export interface PreviewTab {
  id: string;
  label: string;
  content: string;
}

interface PreviewDialogProps {
  title: string;
  tabs: PreviewTab[];
  open: boolean;
  onClose: () => void;
  onApply?: () => void;
  applyLabel?: string;
  showCopy?: boolean;
}

export function PreviewDialog({
  title,
  tabs,
  open,
  onClose,
  onApply,
  applyLabel = 'Apply',
  showCopy = true,
}: PreviewDialogProps) {
  const [activeTab, setActiveTab] = React.useState(() => tabs[0]?.id ?? '');
  const [copied, setCopied] = React.useState(false);

  const activeTabContent = tabs.find((t) => t.id === activeTab)?.content ?? '';

  const handleCopy = () => {
    navigator.clipboard.writeText(activeTabContent);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!open) {
    return null;
  }

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>{title}</h3>
          <button
            type="button"
            className="ghost"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
        <div className="dialog-content">
          <div className="tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={activeTab === tab.id ? 'active' : ''}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div className="dialog-body">
            <pre className="mono">{activeTabContent}</pre>
          </div>
        </div>
        <div className="dialog-footer">
          <div className="row" style={{ justifyContent: 'space-between', width: '100%' }}>
            <div className="row">
              {showCopy && (
                <button
                  type="button"
                  className="secondary"
                  onClick={handleCopy}
                >
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              )}
            </div>
            <div className="row">
              <button
                type="button"
                className="secondary"
                onClick={onClose}
              >
                Close
              </button>
              {onApply && (
                <button
                  type="button"
                  onClick={onApply}
                >
                  {applyLabel}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
